// eslint-disable-next-line
export default {
    translations: {
        header: {
            who: 'WHO AM I?',
            projects: 'PROJECTS'
        },
        footer: {
            contact: 'CONTACT',
            phone: 'Phone',
            email: 'Email:',
            address: 'Address:',
        },
        who: {
            about: 'ABOUT ME',
            title: "I'm Full-stack developer",
            subtitle: 'at Accordous',
            description: 'I am a Full Stack developer at Accordous contributing to the development of APIs, interface components and UX for several Brazilian customers in a efficient and small team. We are working with frameworks for PHP and JS languages in the Laravel + VueJs stack.'
        },
        projects: {
            experience: 'Experience',
            accordous: {
                enterprise: 'Accordous',
                position: 'Full-stack developer',
                description: "Currently, I work at Accordous, I contribute with the development of new functionalities, " +
                    "user experience and interface component for dozens of clients in Brazil and carrying out Full-Stack tasks" +
                    " alongside development team teams with programming languages such as PHP, Javascript . I am responsible for " +
                    "the implementation of new responsive interfaces and new features, using Docker, flow with CI / CD and follower " +
                    "of clear code ideas, also using methods like Scrum to speed up the implantation of new features in the system.",
            },
            genesis: {
                enterprise: 'Gênesis Tecnologia',
                position: 'Full-stack developer Junior',
                description: "Gênesis Tecnologia e Inovação is a company focused on developing solutions for public management, in which I developed and contributed to the creation of the school management system made in React.JS and Laravel. I created dozens of modules for the system, the system being implemented in dozens of cities in Mato Grosso do Sul alongside teams with 6 programmers in which I was the only full-stack developer of the development, we use different programming languages ​​like Javascript, PHP, I developed the system using DDD and TDD modeling, developed API, prototyped and managed the UX Design stack, used the css tool the styled component to componentize screens, did backend integration tests and followed the team with the development of scrum software for continuous deliveries.",
            }
        },
        other: {
            other: "OTHERS PROJECTS",
            title: "The developed websites",
            herval: {
                enterprise: 'Herval Park Hotel',
                description: 'I was responsible for the development of the backend and integration with the frontend, ' +
                    'I also put the website on the air',
            },
            meltt: {
                enterprise: 'Meltt Eventos',
                description: 'I was responsible for developing the interface and backend of a trainee photo management system with 150 users, I put it on the air.',
            },
            apx: {
                enterprise: 'APX³',
                description: 'I was responsible for the development of the backend in which I used the Laravel framework, ' +
                    'used services and repositories. The system is responsible for publishing and managing properties for ' +
                    'sale for this real estate company.',
            },
            bikcraft: {
                enterprise: 'Bikcraft',
                description: 'Site developed with html and css to develop me more in the frontend.',
            },
            dona: {
                enterprise: 'Dona Santa Alimentos',
                description: 'Site developed with html, css, bootstrap and in backend PHP, connection mysql.',
            },
            result: {
                enterprise: 'Result Now',
                description: 'Site developed with html, css, bootstrap and in backend PHP, connection mysql.',
            },
            commands: {
                enterprise: 'Comanda APP',
                description: 'The project is in Laravel, he used a theme in AdminLTE, I changed it to Sego',
            },
            converter: {
                enterprise: 'Converter CSV',
                description: 'The project was published on netlify and was done in react.js to receive an unstructured csv and perform operations such as checking if the file has repeated items in the lines, grouping them and performing sum operations between their fields',
            },
        },
        packages: {
            other: 'Others projects',
            title: 'The developed packages and open-source contributions',
            digital: {
                title: 'Package Digital Signed - API D4Sign',
                description: "I developed this package focused on Laravel, as this official package is made in PHP, but this official package the last update at the time I created it was 3 years old, " +
                    "I see if there was no such package for Laravel I developed, I used guzzle and services, providers and a future implementation of facades to abstract a little more.",
            },
            tenancy: {
                title: 'Multitenancy in Practice - Kevin Mckee',
                description: "I created a PR that did the update from Laravel 7.x to Laravel 8.x using Sail, this project was done by Laracast with Professor KEVIN MCKEE",
            },
            asaas: {
                title: 'Asaas SDK - Unofficial',
                description: "I created a feature that there was no package from asaas which is to send a main account to asaas, this main account is useful to receive payment of invoices without the need to register manually",
            }
        }
    }
}
